import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
import Link from '../Common/Link';
interface Props {
  prev?: string;
  next?: string;
  prevLabel?: string;
  nextLabel?: string;
}

const NextPrevNav = ({ prev, next, prevLabel, nextLabel }: Props) => {
  return (
    <nav className="nextprev text-center hide-for-client-meeting">
      <div className="inner">
        {prev ? (
          <Link href="/inspirations/[id]" as={prev}>
            <div className="btn prev">
              <MdNavigateBefore />
              <span>{prevLabel}</span>
            </div>
          </Link>
        ) : (
          <div></div>
        )}
        {next ? (
          <Link href="/inspirations/[id]" as={next}>
            <div className="btn next">
              <span>{nextLabel}</span>
              <MdNavigateNext />
            </div>
          </Link>
        ) : (
          <div></div>
        )}
      </div>
      <style jsx>
        {`
          .nextprev .btn,
          .nextprev .btn:focus,
          .nextprev .btn:active {
            box-shadow: none;
          }
          .nextprev .inner {
            display: flex;
            justify-content: space-between;
          }
          .nextprev svg {
            width: 40px;
            height: auto;
          }
          .nextprev .btn {
            display: flex;
            align-items: center;
          }

          .nextprev span.btn {
            opacity: 0.5;
          }
        `}
      </style>
    </nav>
  );
};

export default NextPrevNav;
